const isCategoryInProjectCategories = (project, category) => {
  return !!project.categories?.find(
    (item) => typeof item === 'object' ? (item.id === category.id) : item === category.id
  );
};

export default isCategoryInProjectCategories;
